import { useEffect, useState } from 'react';
/*
Calculates the width of the parent container and updates it on resize 
to enable child to have responsive behavior
not tied to browser window width
*/
export const useParentWidth = (ref: HTMLDivElement | null) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (ref) {
        setWidth(ref?.offsetWidth);
      }
    };

    handleResize(); // Initial width
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [ref]);

  return { width };
};
